var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUserCheck = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0 -2.167)" },
                React.createElement("path", { d: "M19.3,26.9v-2.2c0-2.4-1.9-4.3-4.3-4.3H7.4c-2.4,0-4.3,1.9-4.3,4.3v2.2" }),
                React.createElement("path", { d: "M15.5,11.8c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3\n\t\tC13.6,7.4,15.5,9.4,15.5,11.8L15.5,11.8z" }),
                React.createElement("path", { d: "M20.4,16.1l2.2,2.2l4.3-4.3" })))));
});
export default IconUserCheck;
//# sourceMappingURL=IconUserCheck.js.map